import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {WorkerModel} from "@shared/models/worker.model";

@Component({
  selector: 'wm-driver-deactivation-modal',
  templateUrl: './driver-deactivation-modal.component.html'
})
export class DriverDeactivationModalComponent implements OnInit {

  isLoading = false;

  constructor(
    private dialogRef: MatDialogRef<DriverDeactivationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public worker: WorkerModel
  ) { }

  ngOnInit(): void {
  }

  onDeactivate() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close();
  }
}
